import React from 'react';
import HeroSlider from '../components/HeroSlider';
import RoomBooking from '../components/RoomBooking';
import Amenities from '../components/Amenities';
import Rooms from '../components/Rooms';
import Testimonials from '../components/Testimonials';
import Attractions from '../components/Attractions';
import Blogs from '../components/Blogs';

const Home = () => {
  return (
    <>
      <HeroSlider />
      {/* <RoomBooking /> */}
      {/* <Amenities /> */}
      {/* <Rooms /> */}
      
      <Attractions />
      <Testimonials />
      {/* <Blogs /> */}
    </>
  );
};

export default Home; 